__turbopack_context__.v({
  "container": "ArticleHeadlineContent-module-scss-module__eMV9UW__container",
});
